<template>
  <header
    title="header"
    class="w-full bg-stone-100 z-50 print:hidden"
  >
    <div class="flex flex-row justify-between items-center px-8 pt-8 mx-auto max-w-[1920px]">
      <div class="flex flex-col gap-8 justify-between h-full">
        <router-link to="/">
          <img
            src="/images/icons/logo-main-pc.png"
            class="w-[90px]"
          >
        </router-link>
        <div class="flex self-stretch h-full items-center text-sm font-medium text-center text-gray-500">
          <ul class="flex h-full flex-wrap items-end">
            <li
              class="customMenu h-full cursor-pointer"
              @mouseover="handleCustomMouseOver"
              @mouseleave="handleCustomMouseLeave"
            >
              <div
                class="main-category-menu-item text-[#ff5733] hover:border-[#ff5733] font-semibold lg:ml-1"
                :class="customMenuOpen ? 'border-[#ff5733]' : ''"
                @click="()=>goTo({name:'CustomLanding'})"
              >
                Custom
              </div>
            </li>
            <li
              class="allProduct h-full cursor-pointer"
              @mouseover="handleMouseOver"
              @mouseleave="handleMouseLeave"
            >
              <div
                class="main-category-menu-item"
                :class="allProduct ? 'border-active' : ''"
              >
                {{ $t('All Products') }}
              </div>
            </li>
            <li
              class="cursor-pointer"
              @click="()=>goTo({name:'TssaMain'})"
            >
              <div
                class="main-category-menu-item"
              >
                {{ $t('TSSA') }}
              </div>
            </li>
            <li
              class="cursor-pointer"
              @click="()=>goTo({name:'Diy'})"
            >
              <div
                class="main-category-menu-item"
              >
                {{ $t('Contents') }}
              </div>
            </li>
            <li
              class="cursor-pointer"
              @click="()=>goTo({name:'Category', params:{categoryId:12}})"
            >
              <div
                class="main-category-menu-item"
              >
                Sale
              </div>
            </li>
            <li
              class="cursor-pointer"
              @click="()=>goTo({name:'Promotion'})"
            >
              <div
                class="main-category-menu-item"
              >
                Promotion
              </div>
            </li>
            <li
              class="cursor-pointer"
              @click="()=>goTo('/customer/manufacturing-inquiry/board')"
            >
              <div
                class="main-category-menu-item text-[#ff5733] hover:border-[#ff5733] font-semibold"
              >
                {{ $t('OEM/ODM 문의') }}
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="flex flex-col gap-6">
        <div class="justify-center items-center gap-5 inline-flex">
          <nav
            class="justify-start items-center gap-2 flex cursor-pointer"
            @click="()=>router.push({
              name: 'Cart'
            })"
          >
            <img
              src="/images/icons/cart.png"
              class="w-6 h-6"
              alt=""
            >
            <div class="text-center text-stone-700 text-base font-semibold leading-none">
              {{ $t('장바구니') }}
            </div>
          </nav>
          <nav
            class="justify-start items-center gap-2 flex cursor-pointer"
            @click="loginOrMyPage"
          >
            <div class="relative">
              <img
                src="/images/icons/user.png"
                class="w-6 h-6"
                alt=""
              >
              <div
                v-if="notification.getUnreadCount"
                class="w-4 h-4 -right-1.5 -top-1 text-white text-xs bg-red-400 rounded-full justify-center items-center flex absolute"
              >
                {{ notification.getUnreadCount }}
              </div>
            </div>
            <div class="text-center text-stone-700 text-base font-semibold leading-none">
              {{ (sessionStore.authenticated) ? $t('마이페이지') : $t('로그인') }}
            </div>
          </nav>
          <nav
            class="justify-start items-center gap-2 flex cursor-pointer"
            @click="()=>goTo({name:'CustomerCenter'})"
          >
            <img
              src="/images/icons/phone-filled.svg"
              class="w-6 h-6"
              alt=""
            >
            <div class="text-center text-stone-700 text-base font-semibold leading-none">
              {{ $t('고객센터') }}
            </div>
          </nav>
          <div class="justify-start items-center gap-2 flex cursor-pointer">
            <iconic-select
              v-model:value="currency"
              icon="/images/icons/globe.png"
              transparent
              @change="changeLanguage"
            >
              <template
                v-for="(item) in getLanguageList"
                :key="item.value"
              >
                <iconic-option
                  :value="item.value"
                >
                  <span class="text-center text-stone-700 text-base font-semibold leading-none">{{ item.label }}</span>
                </iconic-option>
              </template>
            </iconic-select>
          </div>
        </div>
        <div class="w-full relative mb-2">
          <iconic-input
            v-model:value="keyword"
            class="w-full bg-clear h-full"
            :placeholder="$t('검색어를 입력하세요.')"
            icon="/images/icons/search.svg"
            @submit="()=>{ submitKeyword() }"
          />
        </div>
      </div>
    </div>
    <!-- custom popover -->
    <div
      class="absolute left-0 w-full bg-white"
      :class="customMenuOpen ? 'z-[1000]' : 'z-[-999]'"
    >
      <div
        class="flex w-full bg-white border-b border-stone-700 justify-start items-center opacity-0 transition-opacity duration-300"
        :class="customMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'"
        @mouseover="handleCustomMouseOver"
        @mouseleave="handleCustomMouseLeave"
      >
        <section
          class="flex flex-col w-full h-full self-stretch justify-center items-start gap-2 p-8"
        >
          <div class="justify-center items-center inline-flex">
            <section
              v-for="(menu, index) in customMenuItems"
              :key="menu.title"
              class="pr-4 pl-4 flex flex-inline cursor-pointer gap-4 transition-all duration-150 items-center"
              @mouseenter="customSelected = index"
              @click="() => goTo(menu.route)"
            >
              <nav class="flex items-center gap-2">
                <span
                  class="text-stone-700 text-base font-semibold leading-none transition-colors"
                  :class="customSelected === index ? 'text-[#ff5733]' : ''"
                >
                  {{ $t(menu.title) }}
                </span>
                <span
                  v-if="menu.subtitle"
                  class="text-stone-400 text-sm leading-none"
                >
                  {{ $t(menu.subtitle) }}
                </span>
              </nav>
            </section>
          </div>
          <div class="w-full flex flex-row justify-between items-start mt-4 pt-8 border-t border-stone-300 self-stretch">
            <div class="flex flex-1 items-start gap-10">
              <div class="flex flex-col gap-4">
                <div class="w-[200px] h-[200px] bg-stone-100 overflow-hidden">
                  <img
                    :src="customMenuItems[customSelected].image"
                    class="w-full h-full object-cover"
                    :alt="$t(customMenuItems[customSelected].imageAlt)"
                  >
                </div>
                <div class="text-stone-700 text-sm font-semibold leading-snug">
                  {{ $t(customMenuItems[customSelected].imageCaption) }}
                </div>
              </div>
              <div class="flex-1 max-w-3xl text-stone-600 text-base leading-relaxed">
                {{ $t(customMenuItems[customSelected].description) }}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- popover category -->
    <div
      class="absolute left-0 w-full bg-white"
      :class="allProduct ? 'z-[1000]' : 'z-[-999]'"
    >
      <div
        class="flex w-full bg-white border-b border-stone-700 justify-start items-center opacity-0 transition-opacity duration-300"
        :class="allProduct ? 'opacity-100' : 'opacity-0 pointer-events-none'"
        @mouseover="handleMouseOver"
        @mouseleave="handleMouseLeave"
      >
        <section
          v-if="rootCategories.length > 0"
          title="상품 카테고리 섹션"
          class="flex flex-col w-full h-full self-stretch justify-center items-start gap-2 p-8"
        >
          <div class="justify-center items-center inline-flex">
            <section
              v-for="(group, p) in rootCategories"
              :key="p"
              class="pr-4 pl-4 flex flex-inline cursor-pointer gap-4 transition-all duration-150 items-center"
              @mouseenter="()=>{ selectedGroup = p; }"
            >
              <nav
                :key="p"
                @click="() => goTo(`/shop/category/${group.id}`)"
              >
                {{ __(group?.name, group?.name_en) }}
              </nav>
            </section>
          </div>

          <div class=" w-full h-full flex flex-row justify-between items-start mt-4 pt-8 pl-4 pr-4 border-t border-stone-300 self-stretch ">
            <div
              v-if="rootCategories[selectedGroup] && rootCategories[selectedGroup]?.descendants[0]?.descendants?.length > 0"
              class="flex gap-12 root-category"
            >
              <nav
                v-for="(submenu, index) in rootCategories[selectedGroup].descendants"
                :key="index"
                class="flex-col justify-start items-start gap-10 inline-flex"
                :class="(submenu.descendants?.length === 0) ? 'no-child-nav':''"
              >
                <div
                  class="flex-col justify-start items-start gap-4 flex"
                >
                  <div
                    class="rounded justify-start items-center gap-2 inline-flex"
                  >
                    <div
                      class="text-center text-stone-700 text-base font-semibold leading-none cursor-pointer"
                      @click="() => goTo(`/shop/category/${submenu.id}`)"
                    >
                      {{ __(submenu?.name, submenu?.name_en) }}
                    </div>
                    <div class="w-4 h-4 relative origin-top-left -rotate-180" />
                  </div>
                  <div
                    class="flex-col justify-start items-start gap-3 flex"
                  >
                    <div
                      v-for="(item, itemIndex) in submenu.descendants"
                      :key="itemIndex"
                      class="text-left text-stone-500 text-base font-normal leading-none cursor-pointer"
                      @click="() => goTo(`/shop/category/${item.id}`)"
                    >
                      {{ __(item?.name, item?.name_en) }}
                    </div>
                  </div>
                </div>
              </nav>
            </div>
            <div
              v-else
              class="flex gap-4 flex-col"
            >
              <div
                class="rounded justify-start items-center gap-2 inline-flex"
              >
                <div
                  class="text-center text-stone-700 text-base font-semibold leading-none cursor-pointer"
                  @click="() => goTo(`/shop/category/${rootCategories[selectedGroup].id}`)"
                >
                  {{ __(rootCategories[selectedGroup]?.name, rootCategories[selectedGroup]?.name_en) }}
                </div>
                <div class="w-4 h-4 relative origin-top-left -rotate-180" />
              </div>
              <div
                class="flex-col justify-start items-start gap-3 flex"
              >
                <div
                  v-for="(item, index) in rootCategories[selectedGroup].descendants"
                  :key="index"
                  class="text-left text-stone-500 text-base font-normal leading-none cursor-pointer"
                  @click="() => goTo(`/shop/category/${item.id}`)"
                >
                  {{ __(item?.name, item?.name_en) }}
                </div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="shrink-0 self-stretch pl-8 py-10 border-l border-stone-300 flex-col justify-start items-start gap-10 inline-flex"
        >
          <div class="flex-col justify-start items-start gap-6 flex">
            <div class="rounded justify-start items-center gap-2 inline-flex">
              <div
                class="text-center text-stone-700 text-base font-semibold leading-none cursor-pointer"
                @click="()=>goTo({name: 'BestSeller'})"
              >
                Best seller
              </div>
              <div class="w-4 h-4 relative origin-top-left -rotate-180" />
            </div>
            <div class="rounded justify-start items-center gap-2 inline-flex">
              <div
                class="text-center text-stone-700 text-base font-semibold leading-none cursor-pointer"
                @click="()=>goTo({name: 'ProductNewItem'})"
              >
                What’s new
              </div>
              <div class="w-4 h-4 relative origin-top-left -rotate-180" />
            </div>
            <div class="rounded justify-start items-center gap-2 inline-flex">
              <div
                class="text-center text-stone-700 text-base font-semibold leading-none cursor-pointer"
                @click="()=>goTo('/contents/diy')"
              >
                Content
              </div>
              <div class="w-4 h-4 relative origin-top-left -rotate-180" />
            </div>
          </div>
          <div class="h-24 pr-12 flex-col justify-start items-start gap-4 flex">
            <div class="flex-col justify-start items-start gap-3 flex">
              <div
                class="text-center text-stone-700 text-base font-normal leading-none cursor-pointer"
                @click="()=>goTo({name:'CustomerProductReview'})"
              >
                {{ $t("상품후기") }}
              </div>
              <div
                class="text-center text-stone-700 text-base font-normal leading-none cursor-pointer"
                @click="goTo({name:'CustomerProductInquiry'})"
              >
                {{ $t("상품문의") }}
              </div>
              <div
                class="text-center text-stone-700 text-base font-normal leading-none cursor-pointer"
                @click="()=>goTo({name:'CustomerCenter'})"
              >
                {{ $t("주문/배송문의") }}
              </div>
              <div
                class="text-center text-stone-700 text-base font-normal leading-none cursor-pointer"
                @click="()=>goTo({name:'OfflineStore'})"
              >
                {{ $t("오프라인 스토어") }}
              </div>
            </div>
          </div>
          <div class="h-10 pr-12 flex-col justify-start items-start gap-4 flex">
            <div class="flex-col justify-start items-start gap-3 flex">
              <div
                class="text-center text-stone-700 text-base font-normal leading-none cursor-pointer"
                @click="()=>router.push({
                  name:'CustomerWholesaleApply'
                })"
              >
                {{ $t("도매신청") }}
              </div>
              <div
                class="text-center text-stone-700 text-base font-normal leading-none"
                @click="()=>router.push({
                  name:'DealerApply'
                })"
              >
                {{ $t("딜러모집") }}
              </div>
            </div>
          </div>
        </section>
        <section
          title="이미지 베너"
          class="p-10 max-w-sm self-stretch"
          @click="logHandle"
        >
          <cms-loader
            name="main-category-banner"
            :closable="false"
          />
        </section>
      </div>
    </div>
  </header>
</template>
<script setup>
import {useRouter} from "vue-router";
import {useSessionStore} from "@/utils/useSessionStore.js";
import {computed, onBeforeMount, onServerPrefetch, ref} from "vue";
import {$confirm} from "@/utils/pluginDialog.js";
import axios from "@/utils/axios.js";
import {$t, __} from "@/i18n/useLanguage.js";
import {useNotification} from "@/utils/useNotification.js";
import CmsLoader from "@/components/Cms/CmsLoader.vue";
import {useClickLog} from "@/utils/useClickLog.js";

const router = useRouter();

const sessionStore = useSessionStore();

const keyword = ref('');
const submitKeyword = () => {
  if (keyword.value.length === 0) return;
  goTo({
    name: 'ProductSearch',
    query: {
      keyword: keyword.value
    }
  })
  keyword.value = '';
}
const getLanguageList = computed(() => {
  let list;

  if (sessionStore.isKorean) {
    list = [
      {value: 'kr', label: '한국어'},
      {value: 'en', label: 'English'},
    ]
  } else {
    list = [
      {value: 'en', label: 'English'},
      {value: 'kr', label: '한국어'},
    ]
  }

  return list;
})
const notification = useNotification();

async function fetch() {
  await getCategories();
}

onServerPrefetch(async () => {
  await fetch()
})
const allProduct = ref(false);
const customMenuOpen = ref(false);
const categories = ref([])

const rootCategories = computed(() => {
  if (!categories.value.length) return [];
  return [
    ...categories.value
  ]
});
const selectedGroup = ref(0)

onBeforeMount(async () => {
  await getCategories();
  if (sessionStore.authenticated) {
    await notification.get();
  }
})

const currency = computed(() => {
  return sessionStore.getLanguage;
});

async function changeLanguage() {

  try {
    if (sessionStore.isKorean) {
      await $confirm('Do you want to change language and currency?')
      await sessionStore.changeLanguage('en', 'usd')
    } else {
      await $confirm('언어와 통화를 변경하시겠습니까?')
      await sessionStore.changeLanguage('kr', 'krw')
    }

    window.location.reload();
  } catch (e) {
    //currency.value = sessionStore.getLanguage;
  }
}

const handleMouseOver = () => {
  allProduct.value = true;
  customMenuOpen.value = false;
};

const handleMouseLeave = () => {
  allProduct.value = false;
};

const handleCustomMouseOver = () => {
  customMenuOpen.value = true;
  allProduct.value = false;
};

const handleCustomMouseLeave = () => {
  customMenuOpen.value = false;
};

function loginOrMyPage() {
  if (sessionStore.authenticated) {
    goTo('/my-page')
  } else {
    goTo('/login')
  }
}

function goTo(url) {
  router.push(url);
  allProduct.value = false;
  customMenuOpen.value = false;
}

const getCategories = async () => {
  try {
    const response = await axios.get('/api/evans-cart/categories-service')
    categories.value = response.data.data;
  } catch (e) {
    console.error(e);
  }
}

const ClickLog = useClickLog();
const logHandle = () => {
  ClickLog.logging(12, '이미지 베너')
}

const customSelected = ref(0);
const customMenuItems = [
  {
    title: 'CW 커스텀 블렌드',
    subtitle: '',
    description: 'CW 커스텀 블렌드 서비스는 CW에서 제공하는 프래그런스 오일, 천연 원료, 조향 베이스, 조향 케미컬을 고객님이 직접 조합해 나만의 포뮬러를 설계하면, 그 비율 그대로 향료를 배합·생산해 드리는 서비스입니다. 최소5kg부터 브랜드 전용 향료로 제작되어 향수, 디퓨저, 룸 스프레이 등 다양한 제품에 활용할 수 있도록 서류까지 완벽 지원해드립니다.',
    image: 'https://image.candleworks.com/cms_pages/15/wQA1GaHA0Z33hxnlpFB1bFAq7Uj7BKnqLhtBm2ED.png',
    imageAlt: '커스텀 블렌드 서비스 이미지',
    imageCaption: 'Custom Blend Service',
    route: {name: 'CustomBlendService'}
  },
  {
    title: 'CW 커스텀 프래그런스',
    subtitle: '',
    description: 'CW 커스텀 프래그런스 서비스는 고객의 브랜드 스토리, 공간, 또는 개인적 감각을 반영한 맞춤형 향을 제작합니다. 브랜드 정체성을 담은 시그니처 향부터 특별한 공간과 퍼스널 프래그런스까지, 다양한 니즈에 창의적으로 응답합니다.',
    image: '/images/custom_fragrances/Custom_Fragrance_01(2560).jpg',
    imageAlt: '커스텀 프래그런스 서비스 이미지',
    imageCaption: 'Custom Fragrance Service',
    route: {name: 'CustomLanding'}
  },
  {
    title: 'CW 커스텀 향수용기',
    subtitle: '',
    description: 'CW 커스텀 향수용기 필터 서비스는 CW에서 제공하는 향수 용기, 펌프, 오버캡을 미리 조합해 확인할 수 있는 기능입니다. 용기에 어울리는 오버캡과 펌프의 다양한 조합을 미리 비교하고, 원하는 구성 그대로 장바구니에 담아 바로 구매해보세요.',
    image: '/images/custom_bottle/navi.jpg',
    imageAlt: '커스텀 향수용기 서비스 이미지',
    imageCaption: 'Custom Perfume Bottle Filter',
    route: {name: 'CustomBottle'}
  }
];
</script>
<style>

.root-category:has(.no-child-nav) {
  flex-direction: column;
}

.main-category-menu-item {
  @apply h-full text-center text-stone-700 text-2xl font-normal leading-7 inline-block mr-5 ml-5 pb-4 border-b-4 rounded-t-lg border-transparent hover:border-active transition-all duration-200;
}

</style>
